<script lang="ts">
	import '$lib/css/base.css';
	import '$ravioli/lib/css/generated/primitive-variables.css';
	import '$ravioli/lib/css/generated/semantic-variables.css';
	import '$ravioli/lib/css/ravioli-common.pcss';
	import Header from '$ravioli/lib/components/Header.svelte';
	import Footer from '$ravioli/lib/components/Footer.svelte';
	import { showFooter, showHeader } from '$lib/stores/layoutStore';
	let { children } = $props();
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
	<link
		rel="preload"
		href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400..700;1,400..700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
		as="style"
	/>
	<link
		rel="stylesheet"
		href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400..700;1,400..700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
	/>
	<link rel="icon" href="/favicons/ravioli.png" />
</svelte:head>

{#if $showHeader}
	<Header />
{/if}

<main data-theme="ravioli">
	{@render children()}
</main>

{#if $showFooter}
	<Footer />
{/if}
